export default {
	name: 'BreedsView'
}